import {
    LOGIN_BEGIN, LOGIN_SUCCESS, LOGIN_FAILURE,
    VERIFY_AUTH_COOKIE_BEGIN, VERIFY_AUTH_COOKIE_SUCCESS, VERIFY_AUTH_COOKIE_FAILURE,
    RECONNECT_BEGIN, RECONNECT_SUCCESS, RECONNECT_FAILURE,
    LOGOUT_BEGIN, LOGOUT_SUCCESS, LOGOUT_FAILURE,
    SET_DARK_MODE,
    SET_DISCONNECT,
    GET_ALL_ACCESS_CREDENTIALS_BEGIN, GET_ALL_ACCESS_CREDENTIALS_SUCCESS, GET_ALL_ACCESS_CREDENTIALS_FAILURE,
} from '../constants/ActionTypes'

const initialState = {

    // Auth
    jwt: null,
    isAuthenticated: false,
    hasLoggedOut: false,

    // Login
    isLoadingLogin: false,
    hasErrorLogin: null,

    // Verify Auth Cookie
    verifiedAuthCookie: null,
    isLoadingVerifyAuthCookie: false,
    hasErrorVerifyAuthCookie: null,

    // Reconnect
    isLoadingReconnect: false,
    hasErrorReconnect: null,

    // Logout 
    isLoadingLogout: false,
    hasErrorLogout: null,

    // Theme
    darkMode: false,

    // Access Credentials
    allCredentials: null,
    isLoadingAllCredentials: false,
    hasErrorAllCredentials: null
}

/**
 * @description Reducer function for handling authentication related actions.
 *
 * @author Maria Eduarda Franke
 * @param {Object} state - The current state.
 * @param {Object} action - The action object.
 * @returns {Object} - The new state.
 */
const ReducerAuth = (state = initialState, action) => {
    switch (action.type) {

        // Login
        case LOGIN_BEGIN: {
            return {
                ...state,
                isAuthenticated: false,
                isLoadingLogin: true,
                hasErrorLogin: null
            }
        }
        case LOGIN_SUCCESS: {
            return {
                ...state,
                isAuthenticated: true,
                jwt: action.payload.token,
                isLoadingLogin: false,
                hasErrorLogin: null,
                hasLoggedOut: false
            }
        }
        case LOGIN_FAILURE: {
            return {
                ...state,
                isAuthenticated: false,
                jwt: null,
                isLoadingLogin: false,
                hasErrorLogin: action.payload
            }
        }

        // Verify Auth Token
        case VERIFY_AUTH_COOKIE_BEGIN: {
            return {
                ...state,
                verifiedAuthCookie: null,
                isLoadingVerifyAuthCookie: true,
                hasErrorVerifyAuthCookie: null
            }
        }
        case VERIFY_AUTH_COOKIE_SUCCESS: {
            return {
                ...state,
                verifiedAuthCookie: action.payload,
                isLoadingVerifyAuthCookie: false,
                hasErrorVerifyAuthCookie: null
            }
        }
        case VERIFY_AUTH_COOKIE_FAILURE: {
            return {
                ...state,
                verifiedAuthCookie: null,
                isLoadingVerifyAuthCookie: false,
                hasErrorVerifyAuthCookie: action.payload
            }
        }

        // Reconnect
        case RECONNECT_BEGIN: {
            return {
                ...state,
                isAuthenticated: false,
                isLoadingReconnect: true,
                hasErrorReconnect: null
            }
        }
        case RECONNECT_SUCCESS: {
            return {
                ...state,
                isAuthenticated: true,
                jwt: action.payload.token,
                isLoadingReconnect: false,
                hasErrorLogin: null,
                hasErrorReconnect: false
            }
        }
        case RECONNECT_FAILURE: {
            return {
                ...state,
                isAuthenticated: false,
                jwt: null,
                isLoadingReconnect: false,
                hasErrorReconnect: action.payload
            }
        }

        // Disconnect
        case SET_DISCONNECT: {
            return {
                ...initialState
            }
        }

        // Logout
        case LOGOUT_BEGIN: {
            return {
                ...state,
                isLoadingLogout: true,
                hasErrorLogout: null
            }
        }
        case LOGOUT_SUCCESS: {
            return {
                ...initialState,
                hasLoggedOut: true,

                isLoadingLogout: false,
                hasErrorLogout: null
            }
        }
        case LOGOUT_FAILURE: {
            return {
                ...state,
                isLoadingLogout: false,
                hasErrorLogout: action.payload
            }
        }

        // Access Credentials
        case GET_ALL_ACCESS_CREDENTIALS_BEGIN: {
            return {
                ...state,
                allCredentials: null,
                isLoadingAllCredentials: true,
                hasErrorAllCredentials: null
            }
        }
        case GET_ALL_ACCESS_CREDENTIALS_SUCCESS: {
            return {
                ...state,
                allCredentials: action.payload,
                isLoadingAllCredentials: false,
                hasErrorAllCredentials: null
            }
        }
        case GET_ALL_ACCESS_CREDENTIALS_FAILURE: {
            return {
                ...state,
                allCredentials: null,
                isLoadingAllCredentials: false,
                hasErrorAllCredentials: action.payload
            }
        }

        // Theme
        case SET_DARK_MODE: {
            return {
                ...state,
                darkMode: action.payload
            }
        }

        default: return state

    }
}

export default ReducerAuth